import { useEffect, useMemo, useRef, useState } from "react";
import { mostraAlertaError } from "../../../../componentes/alerts/sweetAlert";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizard2";
import {
    ImagenProducto,
} from "../../../../configuracion/apiUrls";
import { formatoMoneda } from "../../../../configuracion/validaciones";

const calcularPrecioFinalConTodo = (datosProducto, cantidad, selectedLote = null) => {
    let precioFinal;
    let esMayoreoAplicado = false;
    if (selectedLote && selectedLote.precio) {
        precioFinal = parseFloat(selectedLote.precio);
    } else {
        precioFinal = parseFloat(datosProducto.precio) || 0;
    }
    let precioOriginalProducto = precioFinal;
    if (selectedLote && selectedLote.loteprecios && selectedLote.loteprecios.length > 0) {
        const nivelesMayoreoOrdenadosLote = [...selectedLote.loteprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenadosLote) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }
    else if (!selectedLote && datosProducto.productoprecios && datosProducto.productoprecios.length > 0) {
        const nivelesMayoreoOrdenados = [...datosProducto.productoprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenados) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }

    return {
        price: precioFinal.toFixed(2),
        precioOriginalProducto: precioOriginalProducto.toFixed(2),
        esMayoreoAplicado,
    };
};

const ModalProductosWizard = ({
    modalIsOpen,
    setModalIsOpen,
    listaProductos,
    agregarAlCarrito,
}) => {
    const [productoSearchTerm, setProductoSearchTerm] = useState("");
    const [productos, setProductos] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedLote, setSelectedLote] = useState(null);
    const [selectedLoteInventario, setSelectedLoteInventario] = useState(null);
    const [cantidadProducto, setCantidadProducto] = useState(1);
    const [mostrarSinExistencia, setMostrarSinExistencia] = useState(false);
    const [pasoActualState, setPasoActualState] = useState(0);
    const setPasoActualRef = useRef(null);

    const transformarProductos = (listaProductos) =>
        Array.isArray(listaProductos)
            ? listaProductos.map((p) => {
                return {
                    id: p.id,
                    nombre: p.nombre,
                    descripcion: p.descripcion,
                    precio: parseFloat(p.precio).toFixed(2),
                    existencia: p.existencia,
                    codigo: p.codigo,
                    imagen:
                        p.productoImagens && p.productoImagens[0]?.imagen
                            ? ImagenProducto + p.productoImagens[0].imagen
                            : "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen",
                    lotes: p.lotes || [],
                    productoprecios: p.productoprecios || [],
                    detallepromocions: p.detallepromocions || [],
                };
            })
            : [];

    useEffect(() => {
        const productosTransformados = transformarProductos(listaProductos);
        setProductos(productosTransformados);
    }, [listaProductos]);

     
     useEffect(() => {
        if(selectedLoteInventario)
            handleFinish();
    }, [selectedLoteInventario]);

    const filteredProductos = productos.filter((producto) =>
        (producto.nombre + producto.codigo)
            .toLowerCase()
            .includes(productoSearchTerm.trim().toLowerCase())
    );

    const [paginaActual, setPaginaActual] = useState(1);
    const productosPorPagina = 5;
    const indexUltimo = paginaActual * productosPorPagina;
    const indexPrimero = indexUltimo - productosPorPagina;
    const productosPagina = filteredProductos.slice(indexPrimero, indexUltimo);
    const totalPaginas = Math.ceil(filteredProductos.length / productosPorPagina);

    const handleSetPasoActual = (setter, currentStep) => {
        setPasoActualRef.current = setter;
        setPasoActualState(currentStep);
    };

    const resetWizardState = () => {
        setSelectedProduct(null);
        setSelectedLote(null);
        setSelectedLoteInventario(null);
        setMostrarSinExistencia(false);
        setCantidadProducto(1);
        if (setPasoActualRef.current) {
            setPasoActualRef.current(0);
        }
    };

    const handleSelectProduct = (product, avanzarPaso) => {
        setSelectedProduct(product);
        setSelectedLote(null);
        setSelectedLoteInventario(null);
        setCantidadProducto(1);
        avanzarPaso();
    };

    const handleSelectLote = (lote, avanzarPaso) => {
        setSelectedLote(lote);
        setSelectedLoteInventario(null);
        avanzarPaso();
    };

    const handleSelectLoteInventario = (loteInventario) => {
        setSelectedLoteInventario(loteInventario);
    };

    const handleFinish = () => {
        if (!selectedProduct) {
            mostraAlertaError("Debe seleccionar un producto.", "Error");
            return;
        }
        if (selectedProduct.lotes && selectedProduct.lotes.length > 0 && !selectedLote) {
            mostraAlertaError("Debe seleccionar un lote para el producto.", "Error");
            return;
        }
        if (selectedLote && selectedLote.loteinventarios && selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').length > 0 && !selectedLoteInventario) {
            mostraAlertaError("Debe seleccionar un inventario para el lote.", "Error");
            return;
        }
        if (cantidadProducto <= 0) {
            mostraAlertaError("La cantidad debe ser mayor a 0.", "Error");
            return;
        }

        const existenciaDisponible = (() => {
            if (selectedLoteInventario) {
                // Si hay inventario seleccionado, usamos su existencia
                return selectedLoteInventario.existencia;
            }
            if (selectedLote) {
                // Si hay lote, pero no inventario (porque no lo requiere), usamos la existencia del lote
                return selectedLote.existencia;
            }
            if (selectedProduct) {
                // Si no hay lote, usamos la existencia del producto
                return selectedProduct.existencia;
            }
            return 0;
        })();

        if (cantidadProducto > existenciaDisponible) {
            mostraAlertaError(
                `La cantidad ${cantidadProducto} que pide excede la existencia disponible ${existenciaDisponible}.`,
                "Error de Existencia"
            );
            return;
        }

        const productoOriginalCompleto = listaProductos.find(p => p.id === selectedProduct.id);
        const productoParaCarrito = {
            ...productoOriginalCompleto,
            cantidad: cantidadProducto,
            imagen: selectedProduct.imagen
        };

        if (selectedLote) {
            productoParaCarrito.loteSeleccionado = selectedLote;
        }
        if (selectedLoteInventario) {
            productoParaCarrito.loteInventarioSeleccionado = selectedLoteInventario;
        }
        const detallesPrecio = calcularPrecioFinalConTodo(
            productoOriginalCompleto,
            cantidadProducto,
            selectedLote
        );

        agregarAlCarrito({ ...productoParaCarrito, ...detallesPrecio });
        if (setPasoActualRef.current) {
            setPasoActualRef.current(0);
        }
        setModalIsOpen(false);
        resetWizardState();
    };

    const isReadyToAdvance = useMemo(() => {
        // Paso 0: Seleccionar Producto
        if (pasoActualState === 0) {
            return !!selectedProduct;
        }

        if (!selectedProduct) return false;

        // Paso 1: Seleccionar Lote
        const requiereLote = selectedProduct.lotes && selectedProduct.lotes.length > 0;

        if (pasoActualState === 1) {
            // Si el producto no requiere lote, es válido. Si requiere, debe haber uno seleccionado.
            return !requiereLote || !!selectedLote;
        }

        return true;
    }, [pasoActualState, selectedProduct, selectedLote]);

    const isReadyToFinish = useMemo(() => {
        if (!selectedProduct) return false;

        const requiereLote = selectedProduct.lotes && selectedProduct.lotes.length > 0;
        if (requiereLote && !selectedLote) return false;

        // Verifica si un lote ha sido seleccionado
        const loteSeleccionadoExiste = !!selectedLote;

        // Inventarios activos para el lote seleccionado
        const inventariosActivos = loteSeleccionadoExiste &&
            selectedLote.loteinventarios &&
            selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo');

        const loteTieneInventariosActivos = inventariosActivos && inventariosActivos.length > 0;

        // Si se seleccionó un lote, pero NO tiene inventarios activos, NO puede finalizar.
        if (loteSeleccionadoExiste && !loteTieneInventariosActivos) {
            return false;
        }

        // Si tiene inventarios activos, es OBLIGATORIO que selectedLoteInventario esté seleccionado.
        if (loteTieneInventariosActivos && !selectedLoteInventario) {
            return false;
        }

        // La cantidad debe ser mayor a 0.
        if (cantidadProducto <= 0) return false;

        return true;
    }, [selectedProduct, selectedLote, selectedLoteInventario, cantidadProducto]);


    const pasosWizard = useMemo(() => [
        {
            etiqueta: "Seleccionar producto",
            contenido: ({ avanzarPaso }) => (
                <>
                    <div className="row mb-3">
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Buscar producto por nombre o código..."
                                value={productoSearchTerm}
                                onChange={(e) => setProductoSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <table className="table table-bordered table-striped table-hover shadow-sm caption-top">
                            <caption>Lista de Productos disponibles</caption>
                            <thead className="bg-dark text-white">
                                <tr>
                                    <th className="d-none d-md-table-cell">Imagen</th>
                                    <th>Detalle del producto</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productosPagina.length > 0 ? (
                                    productosPagina.map((producto) => (
                                        <tr
                                            key={producto.id}
                                            className={selectedProduct?.id === producto.id ? "table-primary" : ""}
                                        >
                                            <td className="align-middle d-none d-md-table-cell">
                                                <img
                                                    src={producto.imagen}
                                                    alt={producto.nombre}
                                                    className="img-thumbnail"
                                                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen" }}
                                                />
                                            </td>
                                            <td>
                                                <strong>{producto.nombre}</strong> <br />
                                                <small className="text-muted">Código: {producto.codigo}</small> <br />
                                                {(() => {
                                                    const {
                                                        price,
                                                    } = calcularPrecioFinalConTodo(producto, 1);
                                                    return (
                                                        <div>
                                                            Precio: {formatoMoneda(price)}
                                                            {producto.productoprecios && producto.productoprecios.length > 0 && (
                                                                <div className="mt-2">
                                                                    <p className="small mb-0 text-muted">Precios por cantidad:</p>
                                                                    <ul className="list-unstyled small">
                                                                        {producto.productoprecios
                                                                            .sort((a, b) => a.cantidad - b.cantidad)
                                                                            .map((tier, idx) => (
                                                                                <li key={idx}>
                                                                                    {tier.cantidad}+ unid.: {formatoMoneda(tier.precio)}
                                                                                </li>
                                                                            ))}
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                            <td className="text-center align-middle">
                                                <button
                                                    className="btn btn-success btn-sm w-100 w-md-auto"
                                                    onClick={() => handleSelectProduct(producto, avanzarPaso)}
                                                >
                                                    {selectedProduct?.id === producto.id ? (
                                                        <>
                                                            <i className="fa-solid fa-check me-1"></i>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa-solid fa-hand-pointer me-1"></i>
                                                        </>
                                                    )}
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-muted">
                                            No se encontraron productos
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-center">
                            <nav className="mt-4">
                                <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                    {/* Botón "Anterior" */}
                                    <li className={`page-item ${paginaActual === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                            aria-label="Anterior"
                                        >
                                            <i className="fas fa-chevron-left me-1"></i> Anterior
                                        </button>
                                    </li>

                                    {/* Renderizado de los números de página con lógica inteligente */}
                                    {
                                        (() => {
                                            const pagesToShow = 5;
                                            const halfPages = Math.floor(pagesToShow / 2);
                                            let startPage = Math.max(1, paginaActual - halfPages);
                                            let endPage = Math.min(totalPaginas, paginaActual + halfPages);

                                            // Ajuste inicial (si estamos cerca del principio)
                                            if (paginaActual <= halfPages) {
                                                endPage = Math.min(totalPaginas, pagesToShow);
                                            }

                                            // Ajuste final (si estamos cerca del final)
                                            if (paginaActual > totalPaginas - halfPages) {
                                                startPage = Math.max(1, totalPaginas - pagesToShow + 1);
                                            }

                                            const pageButtons = [];
                                            for (let i = startPage; i <= endPage; i++) {
                                                pageButtons.push(
                                                    <li
                                                        key={i}
                                                        className={`page-item ${paginaActual === i ? "active" : ""}`}
                                                    >
                                                        <button className="page-link fw-bold" onClick={() => setPaginaActual(i)}>
                                                            {i}
                                                        </button>
                                                    </li>
                                                );
                                            }
                                            return pageButtons;
                                        })()
                                    }

                                    {/* Botón "Siguiente" */}
                                    <li className={`page-item ${paginaActual === totalPaginas ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                            aria-label="Siguiente"
                                        >
                                            Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div> 
                    </div>
                </>
            ),
        },
        {
            etiqueta: "Seleccionar lote",
            contenido: ({ avanzarPaso }) => {
                const todosLotes = selectedProduct?.lotes || [];
                const lotesFiltrados = todosLotes.filter((lote) => {
                    if (lote.estado && lote.estado !== "Disponible" && !mostrarSinExistencia) return false;
                    if (!mostrarSinExistencia) {
                        return parseFloat(lote.existencia || 0) > 0;
                    }
                    return true;
                });
                const hayAgotados = todosLotes.some(l => parseFloat(l.existencia || 0) <= 0);

                return (
                    <>
                        {selectedProduct ? (
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                                    <h5 className="mb-0">Producto: <span className="text-primary">{selectedProduct.nombre}</span></h5>
                                    <div className="form-check form-switch mb-0">
                                        <input
                                            className="form-check-input me-1"
                                            type="checkbox"
                                            role="switch"
                                            id="switchLotesModalCero"
                                            checked={mostrarSinExistencia}
                                            onChange={(e) => setMostrarSinExistencia(e.target.checked)}
                                            style={{ cursor: "pointer" }}
                                        />
                                        <label className="form-check-label small font-weight-bold text-muted" htmlFor="switchLotesModalCero" style={{ cursor: "pointer" }}>
                                            {mostrarSinExistencia ? "Mostrando todos los lotes" : "Ocultando lotes sin existencias (0)"}
                                        </label>
                                    </div>
                                </div>

                                {lotesFiltrados.length > 0 ? (
                                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                        <table className="table table-bordered table-striped table-hover shadow-sm caption-top">
                                            <caption>Lotes disponibles para {selectedProduct.nombre}</caption>
                                            <thead className="bg-dark text-white">
                                                <tr>
                                                    <th>Lote (Nombre, Existencia, Precio)</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lotesFiltrados.map((lote) => {
                                                    const sinExistencia = parseFloat(lote.existencia || 0) <= 0;
                                                    return (
                                                        <tr
                                                            key={lote.id}
                                                            className={selectedLote?.id === lote.id ? "table-primary" : (sinExistencia ? "table-light opacity-75" : "")}
                                                        >
                                                            <td>
                                                                <div className="d-flex align-items-center flex-wrap gap-2">
                                                                    <strong>{lote.nombre_lote}</strong>
                                                                    {sinExistencia && (
                                                                        <span className="badge badge-secondary">Agotado (0)</span>
                                                                    )}
                                                                </div>
                                                                <small className="text-muted">Existencia: {lote.existencia}</small> <br />
                                                                Precio lote: {formatoMoneda(lote.precio)}
                                                                {lote.loteprecios && lote.loteprecios.length > 0 && (
                                                                    <div className="mt-2">
                                                                        <p className="small mb-0 text-muted">Precios por cantidad:</p>
                                                                        <ul className="list-unstyled small">
                                                                            {lote.loteprecios
                                                                                .sort((a, b) => a.cantidad - b.cantidad)
                                                                                .map((tier, idx) => (
                                                                                    <li key={idx}>
                                                                                        {tier.cantidad}+ unid.: {formatoMoneda(tier.precio)}
                                                                                    </li>
                                                                                ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="text-center align-middle">
                                                                <button
                                                                    className="btn btn-success btn-sm w-100 w-md-auto"
                                                                    disabled={sinExistencia}
                                                                    title={sinExistencia ? "Lote sin existencia" : "Seleccionar lote"}
                                                                    onClick={() => handleSelectLote(lote, avanzarPaso)}
                                                                >
                                                                    {selectedLote?.id === lote.id ? (
                                                                        <i className="fa-solid fa-check me-1"></i>
                                                                    ) : (
                                                                        <i className="fa-solid fa-hand-pointer me-1"></i>
                                                                    )}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="alert alert-warning text-center p-3">
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        {hayAgotados && !mostrarSinExistencia ? (
                                            <div>
                                                <span>Los lotes de este producto se encuentran agotados (existencia 0).</span>
                                                <div className="mt-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => setMostrarSinExistencia(true)}
                                                    >
                                                        <i className="fas fa-eye me-1"></i> Mostrar lotes sin existencias
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            "Este producto no tiene lotes asociados."
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="alert alert-info text-center p-3">
                                <i className="fas fa-info-circle me-2"></i>Por favor, seleccione un producto en el paso anterior.
                            </div>
                        )}
                    </>
                );
            },
        },
        {
            etiqueta: "Seleccionar inventario",
            contenido: ({ avanzarPaso }) => (
                <>
                    {selectedProduct ? (
                        <div>
                            <h5 className="mb-2">Producto: <span className="text-primary">{selectedProduct.nombre}</span></h5>
                            {selectedLote && <h6 className="mb-3">Lote: <span className="text-info">{selectedLote.nombre_lote}</span></h6>}

                            {selectedLote && selectedLote.loteinventarios && selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').length > 0 ? (
                                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <table className="table table-bordered table-striped table-hover shadow-sm caption-top">
                                        <caption>Inventarios activos para el lote seleccionado</caption>
                                        <thead className="bg-dark text-white">
                                            <tr>
                                                <th>Inventario (Tipo, Existencia)</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').map((inv) => (
                                                <tr
                                                    key={inv.id}
                                                    className={selectedLoteInventario?.id === inv.id ? "table-primary" : ""}
                                                >
                                                    <td>
                                                        <strong>Tipo: {inv.inventarioTipo?.nombre || "N/A"}</strong> <br />
                                                        <small className="text-muted">Existencia: {inv.existencia}</small>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            className="btn btn-success btn-sm w-100 w-md-auto"
                                                            onClick={() => handleSelectLoteInventario(inv)}
                                                        >
                                                            {selectedLoteInventario?.id === inv.id ? (
                                                                <>
                                                                    <i className="fa-solid fa-check me-1"></i>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa-solid fa-hand-pointer me-1"></i>
                                                                </>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                !selectedLote && selectedProduct.lotes && selectedProduct.lotes.length > 0 ? (
                                    <div className="alert alert-info text-center p-3">
                                        <i className="fas fa-info-circle me-2"></i>Por favor, seleccione un lote en el paso anterior.
                                    </div>
                                ) : (
                                    <div className="alert alert-warning text-center p-3">
                                        <i className="fas fa-exclamation-triangle me-2"></i>{selectedLote ? 'Este lote no tiene inventarios activos asociados.' : 'Este producto no requiere selección de inventario.'}
                                    </div>
                                )
                            )}
                        </div>
                    ) : (
                        <div className="alert alert-info text-center p-3">
                            <i className="fas fa-info-circle me-2"></i>Por favor, seleccione un producto en el paso anterior.
                        </div>
                    )}
                </>
            ),
        },
    ], [selectedProduct, selectedLote, selectedLoteInventario, cantidadProducto, productoSearchTerm, productosPagina, paginaActual, totalPaginas, listaProductos]);

    const iconosWizard = [
        "fas fa-box",
        "fas fa-boxes",
        "fas fa-warehouse",
    ];

    return (
        <ModalWizardBootstrap
            titulo="Agregar productos al pedido"
            nombreBoton="Agregar producto"
            estiloBoton="btn btn-primary me-2 mb-2 mx-1"
            iconBoton="fas fa-cart-plus mx-2"
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            pasos={pasosWizard}
            iconos={iconosWizard}
            onFinish={handleFinish}
            onClose={resetWizardState}
            onSetPasoActual={handleSetPasoActual}
            size="lg"
            isReadyToAdvance={isReadyToAdvance}
            isReadyToFinish={isReadyToFinish}
        />
    );
};

export default ModalProductosWizard;